import { Component, inject, OnInit, signal } from '@angular/core'
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { Router } from '@angular/router'
import { ApiService } from 'app/services'
import { UserLoginSchema } from 'src/app/schemas'
import { ErrorResSchema, IErrorRes } from 'src/app/schemas/base.schema'

@Component({
  selector: 'app-login',
  imports: [FormsModule, ReactiveFormsModule],
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private apiService = inject(ApiService)
  private router = inject(Router)
  private formBuilder = inject(FormBuilder)

  loginForm = this.formBuilder.nonNullable.group({
    email: ['', Validators.required],
    password: ['', Validators.required],
  })

  showPassword = false

  errors = signal<IErrorRes[]>([])

  ngOnInit(): void {
    if (this.apiService.isAuthenticated()) {
      this.router.navigate([''])
    }
  }

  get emailInvalid() {
    return (
      this.loginForm.get('email') &&
      this.loginForm.get('email')?.invalid &&
      (this.loginForm.get('email')?.touched ||
        this.loginForm.get('email')?.dirty)
    )
  }

  get passwordInvalid() {
    return (
      this.loginForm.get('password') &&
      this.loginForm.get('password')?.invalid &&
      (this.loginForm.get('password')?.touched ||
        this.loginForm.get('password')?.dirty)
    )
  }
  // get password() {
  //   return this.loginForm.get('password')
  // }

  onSubmit() {
    const email = this.loginForm.value.email!
    const password = this.loginForm.value.password!
    const validation = UserLoginSchema.safeParse({ email, password })
    if (!validation.success) {
      for (const issue of validation.error.issues) {
        if (issue.path.includes('email')) {
          this.loginForm.controls.email.setErrors({
            validation: issue.message,
          })
        } else if (issue.path.includes('password')) {
          this.loginForm.controls.password.setErrors({
            validation: issue.message,
          })
        }
      }
      // this.errors.set(
      //   Object.entries(validation.error).map(([k, v]) => ({
      //     attr: k,
      //     detail: v,
      //     code: 'validation_error',
      //   })),
      // )
      validation.error
    } else {
      this.apiService.login(email, password).subscribe({
        next: (res) => {
          this.router.navigate([''])
        },
        error: (res: IErrorRes[]) => {
          const validation = ErrorResSchema.array().safeParse(res)
          if (validation.success) {
            this.errors.set(validation.data)
          } else {
            this.errors.set([{ code: 'unknown', detail: 'Unknown Error' }])
          }
        },
      })
    }
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword
  }
}
